<template>
    <image-gallery
        v-if="gallery.length"
        :images="gallery"
        :auto-play="true"
        class="overflow-hidden" />

</template>

<script setup>
import { defineProps, ref } from 'vue'
import { useStore } from 'vuex'
import ImageGallery from "@/app/components/Utils/ImageGallery.vue";

const props = defineProps({
  remoteId: {
    type: String
  },
  orderImg: {
    type: String
  }
})
const gallery = ref([])
const store = useStore()

fetchGallery()

async function fetchGallery() {
  if (!props.remoteId) {
    return
  }

  store.dispatch('eshop/fetchInventoryGallery', {remoteId: props.remoteId})
      .then(g => gallery.value = g)
      .catch(error => console.log(error))
}
</script>
